module.exports = __webpack_public_path__ + "media/images/pc/stores/funabashi/access/chiba_funabashi_point2_2-511950aced95adfb9215c10b67c7114b.jpg";